import { ItemStatus } from '../../item/item-status';
import {Chat} from '../../chat/Chat';
import { ITEM_TYPES } from '../../item/item-types';
// import { ChatFront } from '../../../app/modules/chat/ChatFront';

export class Item {
    clearMemory() {
        this.chat = null;
    }
    public title: string;
    public name: string;
    public description: string;
    public type: ITEM_TYPES;
    public itemID : string;
    public userID : string;
    public chat : Chat;
    public status : ItemStatus;
    private autoInit : boolean = true;
    public localCount;
    public messagesCount: number = 0;
    public itemDetails?: {
        imageUrl?: string;
        thumbnailUrl?: string;
        imageAlt?: string;
        [key: string]: any;
    };
    
    constructor(collection: any ){
            this.title = collection.title??collection.itemTitle;
            this.name = collection.name;
            this.type = collection.type??collection.itemType;
            this.itemID = collection.itemID;
            this.localCount = collection.localCount;
            this.userID = collection.userID;
            this.status = collection.status;
            this.messagesCount = collection.messagesCount || 0;
            this.itemDetails = collection.itemDetails;
            if(collection.localCount == undefined)
                this.localCount = 0;
        
    }
    setUserID(userID: string){
        this.userID = userID;
    }
    setAutoInit(autoInit : boolean){
        this.autoInit = autoInit;
    }
    isAutoInit(){
        return this.autoInit;
    }
    getSimpleModel(){
        let itemData  = Object.assign({}, this);
        let item = new Item(itemData);
        return item;
    }
}